import {ObjectSuggest} from 'mc/lib/field';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

class DruhUcelField extends PureComponent {

    static propTypes = {
        druhUcelList: PropTypes.array.isRequired,
    };

    componentDidMount() {
        const {druhUcelList, onChange} = this.props;
        if (druhUcelList.length === 1 && onChange) {
            onChange(druhUcelList[0]);
        }
    }

    render() {
        const {druhUcelList, ...other} = this.props;
        return <ObjectSuggest dropdown items={druhUcelList} itemValueAttrName="nazev" {...other}/>;
    }

}

export default DruhUcelField;
